import { Grid } from "@mui/material";
import "./ConsultRequestStep.css";
import ConsultSourceInstitution from "./ConsultSourceInstitution/ConsultSourceInstitution";
import ConsultEquivalencyResult from "./ConsultEquivalencyResult/ConsultEquivalencyResult";
import { useRequestdata } from "../Request/useRequestData";

export default function ConsultRequestStep() {
  return (
    <Grid
      container
      direction="column"
      alignContent={'center'}
      height={'100%'}
      className='REQXXI-Step-Container-Component'
    >
      <Grid
        item
        height={'inherit'}
        width={'100%'}
        marginRight={0}
      >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                height={"inherit"}
                wrap="nowrap"
                className="REQXXI-Container-Component"
              >
                <ConsultSourceInstitution requestData={useRequestdata({})} 
                />

                <ConsultEquivalencyResult requestData={useRequestdata({})} />
              </Grid>
      </Grid>
    </Grid>
  );
}
